import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "0",
  class: "feather feather-type"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "none",
      d: "M13.022 21.125q-1.463 0-2.353-.488-.86-.516-1.262-1.52-.373-1.004-.373-2.496V8.874H6.825q-.287 0-.287-.286V7.067q0-.287.287-.287h2.267l.315-3.443q.029-.287.316-.287h1.434q.287 0 .287.287l.029 3.443h4.275q.286 0 .286.287v1.52q0 .287-.286.287h-4.275v7.69q0 1.348.459 1.893.488.545 1.635.545.574 0 1.148-.115.574-.143 1.004-.344.344-.144.344.2v1.579q0 .23-.23.315-.516.201-1.204.344-.689.144-1.607.144z",
      "aria-label": "t"
    }, null, -1)
  ]))]))
}
export default { render: render }